import * as z from 'zod/mini';

export const CustomerTravelplanFilesRequestSchema = z.union([z.number(), z.string()]);

const FileSchema = z.object({
  id: z.number(),
  name: z.string(),
  url: z.string(),
  type: z.string(),
  size: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const CustomerTravelplanFilesResponseSchema = z.object({
  files: z.array(FileSchema),
});
